import gql from 'graphql-tag';

export default gql`
mutation SetAppImage(
        $uuidEndpoint: String!,
        $uuidImage: String!
        ) {
    setImage(input:{
        uuidEndpoint: $uuidEndpoint,
        uuidImage: $uuidImage
    }) {
      verdict
    }
}
`;
